import * as React from 'react';
const PiedeDAtletaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M89.89 73.8c1.64-1.32 6.5-3.33 9.67-2.11 3.17 1.21 5.93 4.1 4.81 7.71-.75 2.42-2.14 6.59-3.08 9.63M104.05 81.41c1.43-1.15 5.68-2.91 8.44-1.85s5.18 3.58 4.2 6.74c-.56 1.8-1.52 4.71-2.3 7.18M117.11 86.53c1.3-.84 4.8-1.56 7.02-.42s3.7 3.8 2.78 6.55-2.37 6.27-2.78 7.43c-.41 1.17-.35 1.61-.23 2.79s1.17 2.57 1.17 2.57"
      className="prefix__cls-2"
    />
    <path
      d="M135.54 130.81c.46-2.46.73-4.67.73-6.51 0-10.53-1.58-11.89-2.69-13.46s-1.28-3.25-.87-5.06c.41-1.82 2.75-3.49 2.5-6.46s-2.37-4.03-4.19-4.36c-1.82-.34-4.48.37-4.48.37M69.17 90.31c0 4.77-4.32 8.42-4.32 20.29 0 9 1.88 17.02 4.23 24.17"
      className="prefix__cls-2"
    />
    <path
      d="M77.91 93.71c-5.72 0-12.35-6.26-12.35-13.87s5.51-12.2 12.65-12.2 11.82 4.25 11.82 11.9-3.15 10.6-3.33 11.9-.18 2.15.61 2.73c.3.22 1.13.47 2.03.7"
      className="prefix__cls-2"
    />
    <circle cx={103.52} cy={102.7} r={7.84} className="prefix__cls-1" />
    <circle cx={103.52} cy={102.7} r={1.12} className="prefix__cls-1" />
  </svg>
);
export default PiedeDAtletaIcon;
